import React from "react";
import {
  Box,
  Grid,
  Typography
} from "@mui/material";
import {
  makeStyles,
} from "@mui/styles";
import clsx from "clsx";

const InformationUserLevel = (props) => {
  const {
    currentStat
  } = props;
  const classes = useStyles();
  const [grade] = React.useState(() => {
    if (currentStat?.actual <= 0) {
      return 0
    }
    const ratio = (currentStat?.norm ?? 0) / (currentStat?.actual ?? 1);
    // truncate to 2 decimals (no rounding)
    return Math.floor(ratio * 100) / 100;
  });
  return (
    <Grid container spacing={3}>
      <Grid item>
        <CurrentLevel level={currentStat.level} grade={currentStat?.grade}/>
      </Grid>
      <Grid item>
        <Grid container spacing={3} wrap="nowrap">
          <Grid item>
            <InformationItem value={currentStat?.norm} message="норма, н/ч"/>
          </Grid>
          <Grid item>
            <InformationItem value={currentStat?.actual} message="факт. время<br/>выполнения,<br/>н/ч"/>
          </Grid>
          <Grid item>
            <InformationItem value={grade} message="оценка<br/>эф.-ти" danger/>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
const CurrentLevel = ({ level, grade }) => {
  const classes = useStyles();
  console.log('level: ', level)
  return (
    <div className={classes.currentLevel}>
      <div className={clsx({
        [classes.currentLevelIcon]: true,
        'level-1': Boolean(level === 1),
        'level-2': Boolean(level === 2),
        'level-3': Boolean(level === 3),
      })}>
        <img src={require('../../../../../assets/svg/statistics/user-level.svg').default}/>
      </div>
      <div>
        <Typography className={clsx({
          [classes.currentLevelTitle]: true,
          'level-1': Boolean(level === 1),
          'level-2': Boolean(level === 2),
          'level-3': Boolean(level === 3),
        })}>Уровень {level}</Typography>
        {Boolean(Number.parseFloat(level) < 3) && (
          <Typography className={classes.currentLevelCaption}>
            До уровня <strong>{level + 1} - {Math.ceil(grade)} н/ч</strong>
          </Typography>
        )}
      </div>
    </div>
  )
}
const InformationItem = ({ value, message, danger }) => {
  const classes = useStyles();
  return (
    <div className={classes.informationItem}>
      <div className={clsx({
        [classes.informationItemBox]: true,
        "--danger": danger
      })}>{value}</div>
      <div
        className={classes.informationItemName}
        dangerouslySetInnerHTML={{
          __html: message
        }}
      />
    </div>
  )
}

const useStyles = makeStyles(() => ({
  currentLevel: {
    gap: "10px",
    display: "flex",
    alignItems: "center",
  },
  currentLevelIcon: {
    width: "90px",
    height: "90px",
    display: "flex",
    alignItems: "center",
    borderRadius: "20px",
    background: "#F3F3F3",
    justifyContent: "center",

    "&.level-1 img": {
      filter: "invert(82%) sepia(7%) saturate(2773%) hue-rotate(331deg) brightness(91%) contrast(85%)",
    },
    "&.level-2 img": {
      filter: "invert(75%) sepia(37%) saturate(14%) hue-rotate(344deg) brightness(98%) contrast(92%)",
    },
    "&.level-3 img": {
      filter: "invert(96%) sepia(98%) saturate(1585%) hue-rotate(316deg) brightness(97%) contrast(109%)",
    },
  },
  currentLevelTitle: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: "26px",
    "&.level-1": {
      color: "#D8A476",
    },
    "&.level-2": {
      color: "#C4C4C4",
    },
    "&.level-3": {
      color: "#FFC446",
    },
  },
  currentLevelCaption: {
    marginTop: "3px",

    fontSize: 14,
    color: "#434146",
    lineHeight: "16px",

    "& strong": {
      fontWeight: "700",
    }
  },

  informationItem: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  informationItemBox: {
    width: "90px",
    height: "90px",
    display: "flex",
    alignItems: "center",
    borderRadius: "20px",
    background: "#F3F3F3",
    justifyContent: "center",

    fontSize: 24,
    color: "#434146",
    fontWeight: "700",
    lineHeight: "26px",
    textAlign: "center",

    "&.--danger": {
      color: "#FF3C43",
    }
  },
  informationItemName: {
    marginTop: "10px",

    fontSize: 12,
    color: "#434146",
    lineHeight: "14px",
    textAlign: "center",
  },
}));

export default InformationUserLevel
